import { render, staticRenderFns } from "./integracao-geral-repasses.vue?vue&type=template&id=741fd98c&scoped=true"
import script from "./integracao-geral-repasses.vue?vue&type=script&lang=ts"
export * from "./integracao-geral-repasses.vue?vue&type=script&lang=ts"
import style0 from "./integracao-geral-repasses.vue?vue&type=style&index=0&id=741fd98c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741fd98c",
  null
  
)

export default component.exports